module.exports = __webpack_public_path__ + "static/media/onboarding-progression.9af2fe02.svg";